function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { isValidElement } from "react";
function isActionType(action) {
    return typeof action[0].value !== 'undefined';
}
export function generateMenuData(actions, isSmall) {
    var menuOptions = [];
    var menuOnSelect = [];
    if (actions && !isValidElement(actions) && isActionType(actions)) {
        actions.forEach(function(element, i) {
            var value = element.value, destructive = element.destructive, onClick = element.onClick, icon = element.icon, rest = _objectWithoutProperties(element, [
                "value",
                "destructive",
                "onClick",
                "icon"
            ]);
            if (i !== 0 || isSmall) {
                menuOptions.push(_objectSpread({
                    value: value,
                    label: function() {
                        return _jsxs("div", {
                            children: [
                                _jsx(_Fragment, {
                                    children: icon
                                }),
                                value
                            ]
                        });
                    },
                    destructive: destructive
                }, rest));
                menuOnSelect.push({
                    value: value,
                    onClick: onClick
                });
            }
        });
    }
    var menuSelectFunction = function(selected) {
        var ref;
        var val = menuOnSelect.find(function(obj) {
            return obj.value === (selected === null || selected === void 0 ? void 0 : selected.value);
        });
        return val === null || val === void 0 ? void 0 : (ref = val.onClick) === null || ref === void 0 ? void 0 : ref.call(val);
    };
    return {
        menuOptions: menuOptions,
        menuSelectFunction: menuSelectFunction
    };
}
